
(function () {
  const VISIBLE = 5;

  function buildCarousel(fieldset, items) {
    fieldset.dataset.luxCarousel = '1';

    const track = document.createElement('div');
    track.className = 'lux-vp-track';
    items.forEach(l => track.appendChild(l));

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'lux-vp-btn lux-vp-btn--prev';
    prev.textContent = '‹';
    prev.setAttribute('aria-label', 'Previous');

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'lux-vp-btn lux-vp-btn--next';
    next.textContent = '›';
    next.setAttribute('aria-label', 'Next');

    const carousel = document.createElement('div');
    carousel.className = 'lux-vp-carousel';
    carousel.appendChild(prev);
    carousel.appendChild(track);
    carousel.appendChild(next);

    const legend = fieldset.querySelector('legend');
    if (legend) legend.after(carousel);
    else fieldset.prepend(carousel);

    function getStep() {
      return (items[0] ? items[0].offsetWidth + 4 : 40);
    }

    function updateButtons() {
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      prev.style.opacity = atStart ? '0.25' : '1';
      next.style.opacity = atEnd ? '0.25' : '1';
    }

    prev.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateButtons, { passive: true });

    setTimeout(updateButtons, 100);
  }

  function initCarousels() {
    // Native Horizon product-card variant pickers
    document.querySelectorAll('product-card fieldset.variant-option--buttons').forEach(fieldset => {
      if (fieldset.dataset.luxCarousel) return;

      const labels = Array.from(fieldset.querySelectorAll('.variant-option__button-label'));
      if (labels.length <= VISIBLE) return;

      buildCarousel(fieldset, labels);
    });

    // AI carousel block variant pickers
    document.querySelectorAll('fieldset.ai-cc-variant-field').forEach(fieldset => {
      if (fieldset.dataset.luxCarousel) return;
      const btns = Array.from(fieldset.querySelectorAll('a.ai-cc-vbtn'));
      if (btns.length <= VISIBLE) return;
      buildCarousel(fieldset, btns);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  new MutationObserver(initCarousels).observe(document.body, { childList: true, subtree: true });
})();
